import React from 'react';
import CoreLoadingAnimation, { CoreLoadingAnimationLoadingType } from './core-loading-animation';
import { UIProperties } from '../UIProperties';

const CoreLoadingUI = (props: UIProperties<CoreLoadingUIConfig>) => {
	return (
		<div style={{
			width: '100%',
			height: '100%',
			pointerEvents: 'all',
			backgroundColor: 'rgba(0,0,0, 0.75)',
			zIndex: 10000,
			position: 'absolute',
			left: '0',
			top: '0',
			...props.parameters.customRootStyle
		}}>
			<div id='core-loading-start' style={{
				position: 'absolute',
				left: '50%',
				top: '50%',
				transform: 'translate(-50%, -50%)',
				width: props.parameters.loadingContainerWidth + 'px',
				height: props.parameters.loadingContainerHeight + 'px'
			}} tabIndex={0} aria-label='Loading'>
				<CoreLoadingAnimation zoom={props.parameters.loadingZoomLvl} type={props.parameters.loadingType}></CoreLoadingAnimation>
				<br />
				<br />
				<CoreLoadingAnimation zoom={props.parameters.loadingZoomLvl} type={CoreLoadingAnimationLoadingType.six}></CoreLoadingAnimation>
			</div>
			<div style={{opacity: '0'}} id='core-loading-end' tabIndex={0} aria-label='End of content'></div>
		</div>
	);
}

export interface CoreLoadingUIConfig {
	loadingContainerWidth: number;
	loadingContainerHeight: number;
	loadingZoomLvl: number,
	loadingType: CoreLoadingAnimationLoadingType;
	customRootStyle?: any;
}


export default CoreLoadingUI;